import { useCallback, useEffect, useState } from "react";
import { chatApi } from "../api";

export type Conversation = {
  id: string;
  title: string;
  created_at: string;
  updated_at: string;
};

export function useConversations() {
  const [conversations, setConversations] = useState<Conversation[]>([]);

  const reload = useCallback(() => {
    chatApi
      .listConversations()
      .then((res) =>
        setConversations(Array.isArray(res.data) ? res.data : []),
      )
      .catch(() => {});
  }, []);

  useEffect(() => {
    reload();
  }, [reload]);

  useEffect(() => {
    window.addEventListener("conversation-updated", reload);
    return () => window.removeEventListener("conversation-updated", reload);
  }, [reload]);

  const removeConversation = useCallback(
    (id: string) =>
      chatApi.deleteConversation(id).then(() => {
        setConversations((prev) => prev.filter((c) => c.id !== id));
      }),
    [],
  );

  return { conversations, reload, removeConversation };
}
